import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
  approveUser,
  denyUser,
  fetchUnapprovedUsers,
  selectDeny,
  selectLoading,
  selectSuccess,
  selectUnApprovedusers
} from '../../features/users/usersSlice'

import { Button, Card, Form, Input, Space, Table, message } from 'antd'
import { Layout } from '../../components/Layout'
import { Spinner } from '../../components/Spinner'

import { IS_ADMIN } from '../../constants'


const tailItemLayout = {
  wrapperCol: {
    xs: {
      span: 24
    },
    md: {
      offset: 6,
      span: 12
    }
  }
}

const COLUMNS = [
  {
    dataIndex: 'email',
    title: 'Email',
    width: 120
  },
  {
    dataIndex: 'first_name',
    title: 'First Name',
    width: 150
  },
  {
    dataIndex: 'last_name',
    title: 'Last Name',
    width: 150
  },
]

export const ApproveUser = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchUnapprovedUsers());
  }, [dispatch])

  const  unApprovedusers  = useSelector(selectUnApprovedusers);
  const profileLoading = useSelector(selectLoading);
  const [selectedRowKey, setSelectedRowKey] = useState('');
  const [form] = Form.useForm();
  const success = useSelector(selectSuccess);
  const deny = useSelector(selectDeny)
  const isAdmin = localStorage.getItem(IS_ADMIN)
  const windowUrl = window.location.search;
  const params = new URLSearchParams(windowUrl);
  const email = params.get('email')


  useEffect(() => {
    console.log('unApprovedusers', unApprovedusers, )
  }, [unApprovedusers])

  useEffect(() => {
    // console.log('email', email)
    const arr = [email]
    setSelectedRowKey(arr)
    onSelectChange(arr)
    // console.log(arr)
  }, [email])

  useEffect(() => {
    if(success) {
      message.success('User Approved Successfully');
      dispatch(fetchUnapprovedUsers());
      form.setFieldValue("username", '')
      form.setFieldValue("firstname", '')
      form.setFieldValue("lastname", '')
      setSelectedRowKey('')
    }
  }, [profileLoading])

  useEffect(() => {    
    if (deny) {
      message.success('User Denied Successfully');
      dispatch(fetchUnapprovedUsers());
      form.setFieldValue("username", '')
      form.setFieldValue("firstname", '')
      form.setFieldValue("lastname", '')
      setSelectedRowKey('')
    }
  },[deny])

  useEffect(() => {
    form.setFieldValue("email", selectedRowKey[0])
    // console.log(unApprovedusers )
    if(unApprovedusers && unApprovedusers.length > 0) {
      // console.log('selectedRowKey[0]', selectedRowKey[0])
      const user = unApprovedusers.find(user => user.email === selectedRowKey[0])
      // console.log(selectedRowKey)
      if(user) {
        form.setFieldValue("firstname", user.first_name)
        form.setFieldValue("lastname", user.last_name)
        
      }
    }
  }, [selectedRowKey, unApprovedusers])

  if (profileLoading ) return <Spinner />

  const onSubmit = async ({ email }) => {
    // console.log("on submit")
    dispatch(approveUser(email))
  }

  const handleDeny = async ( email ) => {
    try {
      // console.log("on deny")
      dispatch(denyUser(email))
    } catch (e) {
      message.error(e.message);
    }
  }


  const onSelectChange = (selectedRowKeys) => {
    // console.log('selectedRowKeys', selectedRowKeys)
    if (selectedRowKeys.length > 1) {
      const lastSelectedRowIndex = [...selectedRowKeys].pop()
      setSelectedRowKey(lastSelectedRowIndex)
    }
      setSelectedRowKey(selectedRowKeys)
    
  }

  return (
    <Layout.Content>
      {!(isAdmin === 'null' || isAdmin === 'false') ? 
      <Space direction="vertical" size={50} style={{ display: 'flex' }}>
        <Card type="inner" title="Users">
         {<Table columns={COLUMNS}
            dataSource={unApprovedusers}
            rowKey={(record) => `${record.email}`}
            pagination={{ hideOnSinglePage: true }}
            scroll={{ x: 'max-content' }}
            key={selectedRowKey}
            rowSelection={{
              selectedRowKeys : selectedRowKey,
              onChange: onSelectChange,
              type: 'radio',
            }}
          />}
        </Card>
        <Card type="inner" title="Approve User for builty portal Access">
          <Form 
           form={form}
           name="Approve Users"
           onFinish={onSubmit}>
          <Form.Item
            label="Email"
            name="email"
            labelCol={{
              xs: { span: 3 },
              sm: { span: 3 },
              md: { span: 3 },
              lg: { span: 3 },
              xl: { span: 3 }
            }}
            labelAlign={'left'}
           
          >
            <Input placeholder="Email"  disabled/>
          </Form.Item>
          <Form.Item
            label="First Name"
            name="firstname"
            labelCol={{
              xs: { span: 3 },
              sm: { span: 3 },
              md: { span: 3 },
              lg: { span: 3 },
              xl: { span: 3 }
            }}
            labelAlign={'left'}
           
          ><Input placeholder="First Name" disabled/>
          </Form.Item>
            <Form.Item
            label="Last Name"
            name="lastname"
            labelCol={{
              xs: { span: 3 },
              sm: { span: 3 },
              md: { span: 3 },
              lg: { span: 3 },
              xl: { span: 3 }
            }}
            labelAlign={'left'}
            
          ><Input placeholder="Last Name" disabled/></Form.Item>
            
          <Form.Item {...tailItemLayout} style={{ textAlign: 'center'}}>
            <Button type="primary" htmlType="submit" disabled={profileLoading}>Approve user</Button>
                <Button onClick={() => {
                  handleDeny(selectedRowKey[0])
            }}  htmlType="submit" disabled={profileLoading} style={{ marginLeft: '10px' }}>Deny user</Button>
          </Form.Item>
          </Form>
        </Card>
      </Space> : <Space><div className="c-header__inner">
        <div className="c-header__col-main">
          <div className="c-header__subtitle">
              This user does not have access to this page
          </div>
        </div>
        </div></Space> }
    </Layout.Content>
  )
}
